import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateAcademicYear as apiUpdate } from "../../api/apiAcademicYears";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useUpdateAcademicYear() {
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const { mutate: editAcademicYear, isPending: isUpdate, data: results, error } = useMutation({
        mutationFn: ({ req, id }) => apiUpdate(req, id),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["academicYears"] });
            navigate('/academic-years');
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { editAcademicYear, isUpdate, error, results };
}
